var map = {
	"./best-redactions.svg": "4564",
	"./correction.svg": "6203",
	"./credits.svg": "b378",
	"./performance.svg": "a939",
	"./send-redaction.svg": "5de8",
	"./themes.svg": "0fed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "252a";